import { Kategoria as KategoriaGenerated } from 'elegislativa-frontend-ts-axios';

enum KategoriaEnum {
  LEGISLATIVNY = 'LEGISLATIVNY',
  NELEGISLATIVNY = 'NELEGISLATIVNY',
  INY = 'INY',
}

interface Kategoria {
  hodnota: KategoriaEnum,
  nazov: string
}

function mapKategoria(kategoria: KategoriaGenerated): Kategoria | null {
  if (!kategoria) {
    return null;
  }
  return {
    hodnota: KategoriaEnum[kategoria.hodnota],
    nazov: kategoria.nazov,
  };
}

function kategoriaNazov(kategoriaEnum: KategoriaEnum): string {
  switch (kategoriaEnum) {
    case KategoriaEnum.LEGISLATIVNY:
      return 'Právny legislatívny akt';
    case KategoriaEnum.NELEGISLATIVNY:
      return 'Právny nelegislatívny akt';
    case KategoriaEnum.INY:
      return 'Iný akt';
    default:
      throw new Error('Unrecognized dolezitost value.');
  }
}

export {
  KategoriaEnum, Kategoria, mapKategoria, kategoriaNazov,
};
